import { inject, Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { AuthService } from '@k12/app-services';

@Injectable({
  providedIn: 'root'
})
export class SchoolAuthService {
  private readonly msalService: MsalService = inject(MsalService);
  private readonly authService: AuthService = inject(AuthService);
  private readonly institutionGroupPrefix = 'K12-Institutions-';
  private isAuthenticated = false;

  constructor() {
    this.msalService.instance.addEventCallback(async (event) => {
      if (event.eventType.toString() == 'msal:acquireTokenSuccess') {
        const accounts = this.msalService.instance.getAllAccounts();
        if (accounts?.length > 0) {
          this.isAuthenticated = true;
          this.msalService.instance.setActiveAccount(accounts[0]);
        }
      }
    });
  }

  public get isPending(): boolean {
    //if (!this.isAuthenticated) return false;
    return this.authService.userHasAnyRole(['K12.School.Admin.Pending', 'K12.School.User.Pending']);
  }

  /**
   * Rosters need an Approved role and no Pending one. Asking for Approved rather than only ruling out
   * Pending is what keeps a registrant out: their token holds K12.School.New until it is refreshed
   * after provisioning grants Pending, and "not Pending" let that token through.
   */
  public get canAccessRosters(): boolean {
    return (
      this.authService.userHasAnyRole([
        'K12.School.Admin.Approved',
        'K12.School.User.Approved',
        'K12.Institution.Admin.Approved',
        'K12.Institution.User.Approved'
      ]) && !this.isPending
    );
  }

  public get isHDMA(): boolean {
    if (!this.isAuthenticated) return false;
    return this.authService.userHasAnyRole(['K12.School.Admin.Pending', 'K12.School.Admin.Approved']);
  }

  public async isInstitutionHdma(institutionId: string): Promise<boolean> {
    if (!this.isAuthenticated) return false;
    const groups = await this.authService.getUserGroups();
    const institutionGroup = groups.find((group) => group.toLowerCase().startsWith(this.institutionGroupPrefix.toLowerCase()) 
      && group.toLowerCase().includes(institutionId.toLowerCase()));
    return institutionGroup != undefined && this.authService.userHasAnyRole(['K12.Institution.Admin.Approved']);
  }

  public get isNonHDMA(): boolean {
    if (!this.isAuthenticated) return false;
    return this.authService.userHasAnyRole(['K12.School.User.Pending', 'K12.School.User.Approved']);
  }
}
